import React from "react";
import classNames from "classnames";
import TextTruncate from "components/TextTruncate";
import * as styles from "./styles.module.scss";
const SelectItemRenderer = (item, { handleClick, index, modifiers }) => (React.createElement(TextTruncate, { key: `${index}-${item.value}`, text: item.label, className: classNames(styles.itemRenderer, item.className, {
        [styles.disabled]: item.disabled,
        [styles.groupName]: item.isGroupName,
        [styles.active]: modifiers.active, // TODO: find why first item always active when opening
    }), onClick: (e) => !item.disabled && !item.isGroupName && handleClick && handleClick(e) }));
export default SelectItemRenderer;
